const invalidEmailMessage = 'Неверный формат email';

export const email = (value: any) => {
  if (!value) return null;

  if (typeof value === 'string' && value.indexOf('@') < 0) {
    return invalidEmailMessage;
  }
};
